/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Image } from 'app/components';
import { BirthdayRoomWrapper, BirthdayRoomContent } from './styles';

const propTypes = {
  content: PropTypes.oneOfType(PropTypes.array, PropTypes.any),
  fetchContent: PropTypes.func.isRequired
};

const defaultProps = {
  content: null
};

const BirthdayRoom = ({ content, fetchContent }) => {
  const [t, i18n] = useTranslation();
  const [birthdayRoomContent, setBirthdayRoomContent] = useState({
    headline1: '',
    description: '',
    picture: '',
    descriptionPicture: '',
    headline2: '',
    description2: '',
    description3: ''
  });

  useEffect(() => {
    fetchContent();
  }, [i18n.language]);

  useEffect(() => {
    if (content?.length) {
      const {
        headline1,
        headline1EN,
        description,
        descriptionEN,
        picture,
        descriptionPicture,
        descriptionPictureEN,
        headline2,
        headline2EN,
        description2,
        descriptionEN2,
        description3,
        descriptionEN3
      } = content[0];

      setBirthdayRoomContent({
        headline1: i18n.language === 'en' || i18n.language === 'en-US' ? headline1EN : headline1,
        description: i18n.language === 'en' || i18n.language === 'en-US'? descriptionEN : description,
        picture,
        descriptionPicture: i18n.language === 'en' || i18n.language === 'en-US' ? descriptionPictureEN : descriptionPicture,
        headline2: i18n.language === 'en' || i18n.language === 'en-US' ? headline2EN : headline2,
        description2: i18n.language === 'en' || i18n.language === 'en-US' ? descriptionEN2 : description2,
        description3: i18n.language === 'en' || i18n.language === 'en-US' ? descriptionEN3 : description3
      });
    }
  }, [content]);

  return (
    <BirthdayRoomWrapper>
      {content?.length > 0 && (
        <>
          <h1 className="birthday-room__title">{t('common.birthday_room')}</h1>
          <BirthdayRoomContent>
            <div className="birthday-room__container">
              <div className="birthday-room__title-wrapper">
                <h2>{birthdayRoomContent?.headline1}</h2>
                <div className="birthday-room__title-description">
                  {parse(birthdayRoomContent?.description)}
                </div>
              </div>
              <div className="birthday-room__image-wrapper">
                <Image src={birthdayRoomContent?.picture} />
                <h3>{birthdayRoomContent?.descriptionPicture}</h3>
              </div>
              <div className="birthday-room__description2">
                {parse(birthdayRoomContent?.description2)}
              </div>
              <div className="birthday-room__description3-wrapper">
                <h2>{birthdayRoomContent?.headline2}</h2>
                <div className="birthday-room__description3">
                  {parse(birthdayRoomContent?.description3)}
                </div>
              </div>
            </div>
          </BirthdayRoomContent>
        </>
      )}
    </BirthdayRoomWrapper>
  );
};

BirthdayRoom.propTypes = propTypes;
BirthdayRoom.defaultProps = defaultProps;

export default BirthdayRoom;
